import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
/* istanbul ignore next */
Input.install = function (app) {
    app.component(Input.name, Input);
    app.component(Input.Group.name, Input.Group);
    app.component(Input.Search.name, Input.Search);
    app.component(Input.TextArea.name, Input.TextArea);
    app.component(Input.Password.name, Input.Password);
    return app;
};
export { Group as InputGroup, Search as InputSearch, TextArea as Textarea, Password as InputPassword, };
export default Input;
